import React, { useMemo } from "react";
import "./styles.css";
import Text from "../typography/text.js";
import { useLocation } from "react-router-dom";
import { colors } from "../../theme/colors.js";

const INSURANCE_STATUS_STYLES = {
  pending: {
    statusColor: "pending",
    text: "Pending",
    textColor: "primaryColor",
  },
  submitted: {
    statusColor: "submitted",
    text: "Submitted",
    textColor: "primaryColor",
  },
  infoRequired: {
    statusColor: "warning",
    text: "Info Required",
    textColor: "warningColor",
  },
  notCovered: {
    statusColor: "failure",
    text: "Not Covered",
    textColor: "failureColor",
  },
  covered: {
    statusColor: "success",
    text: "Covered",
    textColor: "successColor",
  },
  approved: {
    statusColor: "success",
    text: "Approved",
    textColor: "successColor",
  },
  rejected: {
    statusColor: "failure",
    text: "Rejected",
    textColor: "failureColor",
  },
  completed: {
    statusColor: "success",
    text: "Completed",
    textColor: "successColor",
  },
};

const ORDER_STATUS_STYLES = {
  Completed: {
    statusClass: "Completed",
    textColor: "primaryColor",
  },
  Approved: {
    statusClass: "Approved",
    textColor: "successColor",
  },
  Shipped: {
    statusClass: "Shipped",
    textColor: "primaryColor",
  },
  Pending: {
    statusClass: "Pending",
    textColor: "warningColor",
  },
  Rejected: {
    statusClass: "Rejected",
    textColor: "failureColor",
  },
  "Payment Failed": {
    statusClass: "PaymentFailed",
    textColor: "failureColor",
  },
};

const StatusIndicator = ({ params }) => {
  const location = useLocation();
  const { IsEnabled, Status, RoleType, Icon, InsuranceStatus, HasSentToCollection } =
    params?.data || {};
  const pathName = location.pathname.split("/")[1];

  const colorVar = IsEnabled ? "successColor" : "failureColor";
  const statusType = IsEnabled ? "success" : "failure";

  const statusColor = useMemo(() => {
    if (Icon?.props.count.props.style.color === "#ff0000") {
      return {
        statusColor: "failure",
        text: "Past Due",
        textColor: "failureColor",
      };
    } else if (Icon?.props.count.props.style.color === "#ff9202") {
      return {
        statusColor: "warning",
        text: "Open Balance",
        textColor: "warningColor",
      };
    } else if (Icon?.props.count.props.style.color === "#27a907") {
      return {
        statusColor: "success",
        text: "Fully Paid",
        textColor: "successColor",
      };
    } else {
      return "white";
    }
  }, [params, pathName]);

  const orderStatusStyle = useMemo(() => {
    return ORDER_STATUS_STYLES[Status?.props?.children] ?? null;
  }, [Status]);

  const indicatorColor = useMemo(() => {
    if (orderStatusStyle?.textColor) {
      return orderStatusStyle.textColor;
    }
    if (RoleType?.props?.type === "default") {
      return "primaryColor";
    } else {
      return "darkText";
    }
  }, [orderStatusStyle, RoleType]);

  const renderedText = useMemo(() => {
    if (pathName === "Account") {
      return (
        <>
          <div className={`status status-${statusType}`}></div>
          <Text variant="smallText" color={colorVar}>
            {IsEnabled ? "Available" : "Unavailable"}
          </Text>
        </>
      );
    } else if (pathName === "Orders") {
      return (
        <>
          <div
            className={`status status-${orderStatusStyle?.statusClass ?? "default"}`}
          ></div>
          <Text variant="smallText" color={indicatorColor}>
            {Status.props.children}
          </Text>
        </>
      );
    } else if (pathName === "ASUsers") {
      return (
        <>
          <div className={`status status-${RoleType.props.type}`}></div>
          <Text variant="smallText" color={indicatorColor}>
            {RoleType.props.children}
          </Text>
        </>
      );
    } else if (pathName === "InvoiceDashboard") {
      const IsVoidedInvoice = params.data.IsVoided;
      const isSentToCollection = Boolean(HasSentToCollection);
      return (
        <>
          <div
            className={
              IsVoidedInvoice
                ? `status status-voided`
                : isSentToCollection
                ? `status status-collections`
                : `status status-${statusColor.statusColor}`
            }
          ></div>
          <Text
            variant="smallText"
            color={
              IsVoidedInvoice
                ? "lightText"
                : isSentToCollection
                ? "primaryColor"
                : statusColor.textColor
            }
          >
            {IsVoidedInvoice
              ? "Voided"
              : isSentToCollection
              ? "Sent To Collection"
              : statusColor.text}
          </Text>
        </>
      );
    } else if (pathName === "IVRDetails") {
      console.log(INSURANCE_STATUS_STYLES[InsuranceStatus]?.textColor);
      return (
        <>
          <div
            className={`status status-${INSURANCE_STATUS_STYLES[InsuranceStatus]?.statusColor}`}
          ></div>
          <Text
            variant="smallText"
            color={INSURANCE_STATUS_STYLES[InsuranceStatus]?.textColor}
          >
            {INSURANCE_STATUS_STYLES[InsuranceStatus]?.text}
          </Text>
        </>
      );
    } else if (pathName === "IVRProduct") {
      console.log(INSURANCE_STATUS_STYLES[Status]?.statusColor);
      return (
        <>
          <div
            className={`status status-${INSURANCE_STATUS_STYLES[Status]?.statusColor}`}
          ></div>
          <Text
            variant="smallText"
            color={INSURANCE_STATUS_STYLES[Status]?.textColor}
          >
            {INSURANCE_STATUS_STYLES[Status]?.text}
          </Text>
        </>
      );
    }
  }, [params, pathName, statusType, colorVar, indicatorColor, statusColor, orderStatusStyle, IsEnabled, Status, RoleType, InsuranceStatus]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
      }}
    >
      {renderedText}
    </div>
  );
};

export default StatusIndicator;
